import { render, staticRenderFns } from "./AlarmBin.vue?vue&type=template&id=7853ce48&scoped=true&"
import script from "./AlarmBin.vue?vue&type=script&lang=ts&"
export * from "./AlarmBin.vue?vue&type=script&lang=ts&"
import style0 from "./AlarmBin.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AlarmBin.vue?vue&type=style&index=1&id=7853ce48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7853ce48",
  null
  
)

component.options.__file = "AlarmBin.vue"
export default component.exports